import { render } from "./TextAreaAutoGrow.vue?vue&type=template&id=dff33b4c&ts=true"
import script from "./TextAreaAutoGrow.vue?vue&type=script&lang=ts"
export * from "./TextAreaAutoGrow.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__